module.exports = "/_next/static/images/xsmall-4a3ea306d8e5fe3ab140221609eb9e00.jpg";